import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export type WorkspaceCacheStats = {
  role: string;
  current: {
    bytes_used: number;
    object_count: number;
    monthly_uploaded_bytes: number;
    storage_limit_bytes: number | null;
    retention_days: number | null;
    updated_at: string | null;
  };
  snapshots: Array<{
    bytes_used: number;
    object_count: number;
    monthly_uploaded_bytes: number;
    recorded_at: string;
  }>;
};

export function useWorkspaceCacheStats(workspaceId: string | undefined) {
  return useQuery({
    queryKey: ["workspace", workspaceId, "cache-stats"],
    enabled: Boolean(workspaceId),
    queryFn: () =>
      api<WorkspaceCacheStats>(`/workspaces/${workspaceId}/cache-stats`),
  });
}
